import { getAPI, deleteAPI, postAPI, putAPI } from "../../../api/Networking";

import {
  InventoryProduct,
  PackagingSwagpackDetails,
  PackCreationData,
  ProductSourcingSkuStatusInfo,
  SourcingSwagpackItem,
  SwagpackMediaResult,
  VariantToDelete,
} from "../../../models/ProjectManagement/ProjectPackagingSwagpacks";
import { APIResponse } from "../../../models/NetworkResponse";

export default class ProjectPackagingOpsAPI {
  getPackagingOpsSwagpacks = async (
    projectId: number
  ): Promise<PackagingSwagpackDetails> => {
    try {
      const response = await getAPI(`/admin/orders/order/${projectId}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getSourcingSwagpacks = async (
    projectId: number
  ): Promise<SourcingSwagpackItem[]> => {
    try {
      const response = await getAPI(
        `/v5/projects/sourcing/id/${projectId}/sourcing-info`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getSourcingInfoBySku = async (
    projectId: number
  ): Promise<ProductSourcingSkuStatusInfo[]> => {
    try {
      const response = await getAPI(
        `/v5/projects/sourcing/id/${projectId}/sourcing-info-by-sku`
      );
      return response.result ?? [];
    } catch (error) {
      throw error;
    }
  };

  deletePackagingOpsSwagpack = async (
    inventory_id: number,
    swagpack_id: number,
    payload?: {
      pack_remove_quantity?: number;
      bulk_remove_quantity?: VariantToDelete[];
    }
  ): Promise<APIResponse> => {
    try {
      const response = await deleteAPI(
        `/v5/inventories/inventory/${inventory_id}/swagpack/${swagpack_id}`,
        payload
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getPackagingOpsSwagpackImageVideo = async (
    projectId: number,
    inventoryId: number
  ): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/inventories/inventory/${inventoryId}/get-packaging-media/${projectId}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  uploadPackagingImageVideo = async (
    projectId: number,
    inventoryId: number,
    urls: string[],
    isImageUrl: boolean
  ): Promise<SwagpackMediaResult> => {
    try {
      const payload = isImageUrl ? { image_urls: urls } : { video_urls: urls };

      const response = await postAPI(
        `/v5/inventories/inventory/${inventoryId}/save-packaging-media/${projectId}`,
        payload
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  createSwagPack = async (data: PackCreationData): Promise<any> => {
    try {
      const response = await postAPI(
        `/v5/inventories/inventory/${data.inventory_id}/create/swagpack`,
        data
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  updateSwagpackQuantity = async (
    swagpack_id: number,
    packs_count: number,
    inventory_id: number,
    products: InventoryProduct[],
    order_id: number
  ): Promise<APIResponse> => {
    try {
      const response = await putAPI(
        `/v5/inventories/inventory/${inventory_id}/swagpack/${swagpack_id}/quantity`,
        {
          packs_count,
          products,
          order_id,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  updateSwagpackLabel = async (
    inventory_id: number,
    swagpack_id: number,
    label: string
  ): Promise<APIResponse> => {
    try {
      const response = await putAPI(
        `/v5/inventories/inventory/${inventory_id}/swagpack/${swagpack_id}/label`,
        { label }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  completeProject = async (projectId: number) => {
    try {
      const response = await postAPI(
        `/admin/projects/complete/${projectId}`,
        {}
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  createInventory = async (
    customerId: number,
    label: string,
    orderId: number,
    type: number
  ): Promise<any> => {
    try {
      const response = await postAPI(`/v5/inventories/create`, {
        customerId,
        label,
        orderId,
        type,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };
  deletePackagingMedia = async (
    order_id: number,
    inventory_id: number,
    media_id: number
  ): Promise<APIResponse> => {
    try {
      const response = await deleteAPI(
        "/v5/inventories/inventory/packaging-media",
        {
          order_id,
          inventory_id,
          media_id,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  uploadPackagingPackImage = async (
    inventoryId: number,
    swagpack_id: number,
    imageUrl: string
  ): Promise<APIResponse> => {
    try {
      const response = await putAPI(
        `/v5/inventories/inventory/${inventoryId}/swagpack/${swagpack_id}/image`,
        { image_url: imageUrl }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
